import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GeofenceSetDetails = lazy(() =>
  import("@components/Geofences/GeofenceSetDetails").then((module) => ({
    default: module.GeofenceSetDetails,
  }))
);

export const locationDetailsNRO: NavigationRoutingObject = {
  section: "audience",
  Component: GeofenceSetDetails,
  componentFeatureFlippers: ["locations"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("locations-pill-menu-option", "Locations"),
  pageNameForTracking: () => "Locations",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("locations-description-nav", "Create geofences to trigger messages when a user enters or exits an area"),
  icon: "nav-system-locations",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("locations"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/locations/:appGroupId",
};
